(() => {
  'use strict';
  const rate = document.querySelector('[data-sn-dovetail-rate]');
  const form = rate && rate.closest('form');
  if (!form || form.dataset.snPilotMoneyBound === '1') return;
  const scope = form.closest('[data-section-id], .shopify-section') || document;
  const dataNode = scope.querySelector('script[data-product-json]');
  let data;
  try { data = JSON.parse(dataNode.textContent); } catch (_) { return; }
  // Loaded only for products switched on in snippets/sn-minlen-on.liquid.
  if (!data.product) return;
  const length = form.querySelector('.custom-length__input');
  const pieces = form.querySelector('.custom-length__pieces-input');
  if (!length || !pieces || !Array.isArray(data.product.variants)) return;
  form.dataset.snPilotMoneyBound = '1';
  const money = new Intl.NumberFormat('en-GB', {style: 'currency', currency: 'GBP'});
  const integer = (value) => /^\d+$/.test(String(value)) && Number.isSafeInteger(Number(value)) ? Number(value) : null;
  function variant() {
    const chosen = [];
    for (const field of form.querySelectorAll('.product-form__single-selector')) {
      if (field.type === 'radio' && !field.checked) continue;
      const index = Number(field.getAttribute('data-option-position')) - 1;
      if (Number.isInteger(index) && index >= 0) chosen[index] = field.value;
    }
    if (chosen.length) return data.product.variants.find(v => chosen.every((value, index) => !value || v.options[index] === value));
    const id = form.querySelector('[name="id"]');
    return data.product.variants.find(v => String(v.id) === String(id ? id.value : data.selected_variant_id));
  }
  function render() {
    const v = variant();
    if (!v || !Number.isSafeInteger(v.price) || v.price <= 0) return;
    const mm = integer(length.value);
    const count = integer(pieces.value);
    const min = integer(length.min);
    const max = integer(length.max);
    const valid = mm !== null && count !== null && count > 0 && min !== null && max !== null && mm >= min && mm <= max;
    const amount = valid ? v.price * Math.ceil(mm / 10) * count : v.price * 100;
    if (!Number.isSafeInteger(amount)) return;
    const price = form.querySelector('.price-list .price:not(.price--compare)');
    if (!price) return;
    const label = price.querySelector('.visually-hidden');
    const unit = document.createElement('span');
    unit.className = 'custom-length__price-unit';
    unit.style.cssText = 'font-size:0.7em;opacity:0.75;margin-left:4px;';
    unit.textContent = valid ? `${count} × ${mm}mm` : '/ 1 m';
    const nodes = [document.createTextNode(`${money.format(amount / 100)} `), unit];
    if (label) nodes.unshift(label);
    price.replaceChildren(...nodes);
    rate.textContent = `${money.format(v.price)} / 1 m`;
  }
  let queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; render(); });
  }
  form.addEventListener('input', schedule);
  form.addEventListener('change', schedule, true);
  document.addEventListener('variant:changed', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, {once:true});
  else schedule();
})();
